import { useWhitelabelConfig } from '../../services/useWhitelabelConfig';

import LayoutContent, { TLayoutContent } from './LayoutContent';

export default function LayoutContentForTenant(
  props: Omit<TLayoutContent, 'layoutContentConfig' | 'featureFlags'>
) {
  const {
    wlConfig: { layoutContentConfig, featureFlags },
  } = useWhitelabelConfig();

  return (
    <LayoutContent
      {...props}
      layoutContentConfig={layoutContentConfig}
      featureFlags={featureFlags}
    />
  );
}
export * from './LayoutContent';
